import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import ListImageContainer from '../cares/ListImageContainer';
import Container from '../Container';
import { Typography } from '@material-ui/core';
import config from '../../../helpers/config';

const useStyles = makeStyles(theme => ({
    container: props => ({
        position: 'relative',

        '& .bg': {
            backgroundImage: `url(${config.S3Endpoint}${props.bg})`,
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: '100% 50%',
            position: "absolute",
            right: 0,
            top: 0,
            bottom: 0,
            height: '100%',
            width: '100%'
        },
        '& h4': {
            padding: '15px 0px'
        }
    }),
    hr: {
        height: '1px',
        backgroundImage: 'linear-gradient(to right, #ac9f97 50%, rgba(255,255,255,0) 0%)',
        backgroundPosition: "bottom",
        backgroundSize: "10px 1px",
        backgroundRepeat: "repeat-x"
    },
}));


export default (props) => {
    const classes = useStyles(props);
    const { color } = props;
    return (
        <div className={classes.container}>
            <div className="bg" />
            <Container>
                {props.items && props.items.map((d, i) => {
                    return (<div key={i}>
                        <div className={classes.hr} />
                        <Typography variant="h4"><span style={{color}}>&#10022;&nbsp;&nbsp;</span>{d}</Typography> 
                    </div>);
                })} 
            </Container>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/client/components/core/MainContent.js